import React, { useState, useEffect } from 'react';
import { useCSS } from '../../lib/hooks';

import { SquaredButton } from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection';

const ESCAPE_KEY = 27;

const Wrapper = (props) => {
	return (
		<div class="floating_extra_options_menu">
			<span class="bg" onClick={props.close} />

			{props.children}
		</div>
	)
};

const FloatingExtraOptionsMenu = (props) => {
	const actions = props?.actions ?? false;
	if(actions === false) return null;

	useCSS('comp/floating_extra_options.css');

	const [ display_options, setDisplayOptions ] = useState(false);

	const toggleVisibility = (new_status) => {
		setDisplayOptions(new_status);
		if(props.onToggleVisibility != undefined) props.onToggleVisibility(new_status);
	};

	useEffect(() => {
		document.addEventListener("keydown", handleKeyDown);

		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, []);

	const handleKeyDown = (e) => {
		switch(e.keyCode) {
			case ESCAPE_KEY:
				toggleVisibility(false);
				break;

			default:
				break;
		}
	};

	if(!display_options) {
		return (
			<Wrapper close={() => toggleVisibility(false)}>
				<ButtonCollection>
					{props.children}

					<SquaredButton
						icon={props?.custom_opener_icon ?? 'ep-more-options-v'}
						color={props?.custom_opener_color ?? 'gray'}
						_class={{ other:props?.custom_opener_classes ?? 'menu_opener' }}
						onClick={() => toggleVisibility(true)}
						tooltip={props.custom_opener_tooltip}
						aria-label="Open"
					/>
				</ButtonCollection>
			</Wrapper>
		)
	}

	return (
		<Wrapper close={() => toggleVisibility(false)}>
			<SquaredButton
				icon='ep-delete-circle'
				//color='white'
				onClick={() => toggleVisibility(false)}
				aria-label="Close"
			/>

			<ButtonCollection _class={{other:'actions_display'}}>
				{actions(props.id)}
			</ButtonCollection>
		</Wrapper>
	)
};

export default FloatingExtraOptionsMenu;